module.exports = __webpack_public_path__ + "img/xiazai.f76923bc.png";